import React from 'react';

class Loader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: props.isLoading,
    };
  }

  render() {
    const { isLoading } = this.props;

    if (isLoading)
      return (
        <div className="hu-loader">
          <div className="sk-folding-cube">
            <div className="sk-cube1 sk-cube"></div>
            <div className="sk-cube2 sk-cube"></div>
            <div className="sk-cube4 sk-cube"></div>
            <div className="sk-cube3 sk-cube"></div>
          </div>
          <div className="hu-loader-referral">
            <p className="hu-loader-referral_text hu-color_contrast">
              POWERED BY<br/><b>LANDBOT</b>.io 🤖
            </p>
          </div>
        </div>
      )
    else 
      return null;
  }
}

export default Loader;


// WEBPACK FOOTER //
// ./app/js/components/Loader.js